import {Component, EventEmitter, HostListener, Input, Output} from '@angular/core';

@Component({
  selector: 'app-popup2',
  templateUrl: './popup2.component.html',
  styleUrls: ['./popup2.component.scss'],
  exportAs: 'appPopup',
  standalone: false
})
export class Popup2Component {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @HostListener('document:keydown.escape') keyPress() {
    if (this.visible) {
      this.close();
    }
  }

  constructor() {
  }

  close() {
    this.visibleChange.emit(this.visible = false);
  }

  click(event: MouseEvent) {
    if ((event.target as HTMLElement).className === 'popup-overlay') {
      this.close();
    }
  }
}
